// extracted by mini-css-extract-plugin
module.exports = {"tab_segment":"tab_segment-16gME","tab_checked":"tab_checked-3NhQW"};